export default __webpack_public_path__ + "static/media/ci.7a067489.svg";